// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__EtP-K","legacyBtn":"MutateMid_legacyBtn__DQbQD"};